import {WOStatisticsItem} from "../workOrder/WOStatisticsItem";
export interface WOStatisticsCategory {
  // DB Field
  uid: number;
  companyUID: number;
  categoryName: string;
  displayOrder: number;
  isDeleted: boolean;

  // No DB
  items: WOStatisticsItem[];
}

export const initializeStatisticsCategory: WOStatisticsCategory = {
  // DB Field
  uid: 0,
  companyUID: 0,
  categoryName: "",
  displayOrder: 0,
  isDeleted: false,
  // No DB
  items: [] as WOStatisticsItem[],
};

export interface statisticsCategoryListParams {
  token: string;
  page: number;
  rows?: number;
}
export const initialStatisticsCategoryListParams = {
  page: 1,
  token: "",
  rows: 20,
};
